// extracted by mini-css-extract-plugin
export default {"radioGroup":"RadioGroup_radioGroup__g6GJO","label":"RadioGroup_label__zjBVn"};